module.exports = __webpack_public_path__ + "img/icon-timer.0d7362e8.svg";